exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-actions-hint[data-v-1a5082ff]{margin-bottom:.5rem;font-size:.75rem;opacity:.75}.ai-actions-row[data-v-1a5082ff]{display:flex;align-items:flex-start;gap:.375rem;margin-bottom:.375rem}.ai-actions-row .ai-actions-row__label[data-v-1a5082ff]{flex:0 0 10rem}.ai-actions-row .ai-actions-row__instruction[data-v-1a5082ff]{flex:1}.ai-actions-row .ai-actions-row__seniority[data-v-1a5082ff]{flex:0 0 8.5rem}", ""]);

// exports
